import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const SiteLogo = ({ adjustImages = true, wrapperClasses: passedClasses = [], logoColor = 'white' }) => {
    const wrapperClasses = [...passedClasses];
    wrapperClasses.push('site-logo-link');

    if (adjustImages) {
        wrapperClasses.push('adjust-image-sizes');
    }
    console.log('adjustImages', adjustImages);
    const url = 'https://static.wannasport.dk/vector/';
    const imageNames = ['logo', 'logotype'];

    return (
        <React.Fragment>
            <div>
                <Link
                    to='/'
                >
                    {imageNames.map(name => (
                        <img
                            key={`image-site-${name}`}
                            className={`site-${name}`}
                            src={`${url}${name}-${logoColor}${name === 'logotype' && adjustImages ? '-adjustedHeight' : ''}.svg`}
                            alt={`image-${name}-alt`}
                            width={name === 'logo' ? '9%' : '25%'}
                        />
                    ))}
                </Link>
            </div>
        </React.Fragment>
    );
};

export default SiteLogo;
SiteLogo.propTypes = {
    logoColor: PropTypes.oneOf([
        'white',
        'red',
        'lightgreen',
        'green',
        'deepblue',
        'black'
    ]),
    wrapperClasses: PropTypes.arrayOf(PropTypes.string),
    adjustImages: PropTypes.bool
};
